import { render, staticRenderFns } from "./getFromGoogle.vue?vue&type=template&id=6e1f04b4&"
import script from "./getFromGoogle.vue?vue&type=script&lang=js&"
export * from "./getFromGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports